var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

/**
 * Initializes the hero module.
 * @constructor
 * @param {Object} el - The hero element.
 */
function HomeHero(el) {
	this.$el = $(el);
	this.$slides = this.$el.find('.home-hero__performance');
	this.$listItems = this.$el.find('.home-hero__performance-list li');
	this.slideTimeout = 0;
	this.videoTimeout = 0;

	$('.home-hero__splash').on('animationend', function() {
		this.activateSlide(this.$slides.first());
	}.bind(this));

	$('.home-hero__blue').on('animationend', function() {
		this.$el.addClass('done');
	}.bind(this));

	var $splash = $('.home-hero__splash');
	var splashImageStyle = $splash.css('background-image');

	if(splashImageStyle.indexOf('url(h') === 0) {
		splashImageSrc = splashImageStyle.substr(4, splashImageStyle.length - 5);
	} else {
		splashImageSrc = splashImageStyle.substr(5, splashImageStyle.length - 7);
	}

	var splashImage = new Image();

	splashImage.src = splashImageSrc;

	$(splashImage).one('load', function() {
		this.$el.addClass('ready');
	}.bind(this));

	if(splashImage.complete) {
		$(splashImage).trigger('load');
	}

	this.activateSlide( this.$slides.eq(0) );

	this.$el.on('click', '.home-hero__performance-list li', function(event) {
		this.activateSlide(this.$slides.eq($(event.currentTarget).index()));

		if ($(window).width() > 849) {
			event.preventDefault();
		}
	}.bind(this));
}

HomeHero.prototype = {
	nextSlide: function() {
		var $active = this.$el.find('.home-hero__performance.active');
		var $next = $active.next();

		if(!$next.length) {
			$next = this.$el.find('.home-hero__performance').first();
		}

		this.activateSlide($next);
	},

	activateSlide: function($slide) {
		clearTimeout(this.slideTimeout);
		this.$slides.find('video').off('timeupdate');

		if($slide.find('video').length) {
			this.startVideoSlide($slide);
		} else {
			this.startImageSlide($slide);
		}

		this.$listItems.eq($slide.index()).addClass('active').siblings().removeClass('active');
	},

	startVideoSlide: function($slide) {
		var $video = $slide.find('video');
		var vid = $video[0];
		var startTime = $video.attr('data-start-time');
		var endTime = $video.attr('data-end-time');

		if(startTime) {
			vid.currentTime = parseInt(startTime);
		}

		vid.play();

		$video.closest('.home-hero__performance')
			.addClass('active').removeClass('first')
			.siblings().removeClass('active');

		if(isNaN(endTime)) {
			endTime = '5';
			// $(vid).on('ended', function() {
			// 	$(vid).off('ended');
			// 	this.nextSlide();
			// }.bind(this));
		} /*else {*/
			endTime = parseInt(endTime);

			$(vid).on('timeupdate', function(event) {
				if(vid.currentTime >= endTime) {
					$(vid).off('timeupdate');
					this.nextSlide();
					this.videoTimeout = setTimeout(function() {
						vid.pause();
					}, 500);
				}
			}.bind(this));
		// }
	},

	startImageSlide: function($slide) {
		$slide.addClass('active').removeClass('first')
			.siblings().removeClass('active');

		this.slideTimeout = setTimeout(function() {
			this.nextSlide();
		}.bind(this), 5000);
	}
}

module.exports = HomeHero;